
export { QueryClient } from "/var/www/clients/client1/web1/web/frontend/node_modules/react-query/es/core/index.js"
export { QueryClientProvider } from "/var/www/clients/client1/web1/web/frontend/node_modules/react-query/es/react/index.js"